import { AxiosError } from 'axios';
import DatePicker from 'components/base/DatePicker';
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from 'utils/axiosInterceptors';
import { formatToUTCISO } from 'utils/formatToUTCISO';
import { toastConfig } from 'utils/toastConfig';
import * as yup from 'yup';

type ConfirmCheckFormProps = {
  branchDomain: string;
  supplierPaymentId: string;
};

const ConfirmCheckForm = React.forwardRef<
  { submitForm: () => Promise<boolean | undefined> },
  ConfirmCheckFormProps
>(({ branchDomain, supplierPaymentId }, ref) => {
  const [checkClearedOn, setCheckClearedOn] = useState<string | Date>(
    new Date()
  );

  const schema = yup.object().shape({
    checkClearedOn: yup.string().required('Release date is required')
  });

  const handleSubmit = async () => {
    console.log(formatToUTCISO(checkClearedOn));
    try {
      await schema.validate({ checkClearedOn }, { abortEarly: false });
      await axiosInstance.put(
        `/api/v1/${branchDomain}/supplierPayments/${supplierPaymentId}/confirmCheck`,
        { checkClearedOn: formatToUTCISO(checkClearedOn) }
      );
      toast.success('Check released', { ...toastConfig, autoClose: 2000 });
      return true;
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        error.inner.forEach(err => {
          toast.error(err.message, { ...toastConfig, autoClose: 3000 });
        });
      } else if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  React.useImperativeHandle(ref, () => ({
    submitForm: handleSubmit
  }));

  return (
    <>
      <Form className="w-100">
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Confirm Check</Form.Label>
            <DatePicker
              value={checkClearedOn}
              onChange={date => {
                setCheckClearedOn(date[0]), console.log(date[0]);
              }}
            />
          </Form.Group>
        </Row>
      </Form>
    </>
  );
});

export default ConfirmCheckForm;
